import { renderDocFormModal } from "./documentos.js";

import { getComprometidoPorEntregar, getStockProducto } from "../core/accounting.js";
import { C, DOC_INFO } from "../core/config.js";
import { state } from "../core/state.js";
import { btnStyle, escapeHTML, fmtCOP, inputStyle, parseNumber, searchFilter } from "../core/utils.js";
import { render } from "../ui/app.js";

export function showProductSearch() {
  state.productSearch = state.productSearch || "";
  state.productSearchChecked = {};
  state.productSearchQtys = {};
  renderProductSearchModal();
}

export function handleCatalogQty(el, pid) {
  if (!state.productSearchQtys) state.productSearchQtys = {};
  const val = parseInt(el.value, 10);
  state.productSearchQtys[pid] = (val > 0) ? val : "";
  // Si el usuario ingresa una cantidad, marcar el producto como seleccionado automáticamente
  if (val > 0) {
    if (!state.productSearchChecked) state.productSearchChecked = {};
    state.productSearchChecked[pid] = true;
  }
  // Actualizar el contador de seleccionados en el botón sin re-renderizar todo el modal
  const selectedCount = Object.keys(state.productSearchChecked || {}).filter(id => state.productSearchChecked[id]).length;
  const confirmBtn = document.querySelector("[data-action='confirm-add-selected-products']");
  if (confirmBtn) {
    const tipo = state.editingTipo;
    const isRC = tipo === "RC";
    const label = DOC_INFO && DOC_INFO[tipo] ? DOC_INFO[tipo].label.toLowerCase() : "documento";
    confirmBtn.textContent = `+ Agregar ${selectedCount || ""} a la ${isRC ? "remisión" : label}`;
    confirmBtn.disabled = selectedCount === 0;
    confirmBtn.style.opacity = selectedCount === 0 ? ".5" : "1";
    confirmBtn.style.cursor = selectedCount === 0 ? "not-allowed" : "pointer";
  }
  // Actualizar el contador de seleccionados del pie
  const countLabel = document.querySelector("[data-catalog-count]");
  if (countLabel) countLabel.textContent = `${selectedCount} producto${selectedCount !== 1 ? "s" : ""} seleccionado${selectedCount !== 1 ? "s" : ""}`;
}

export function renderProductSearchModal() {
  const query = state.productSearch || "";
  const allProducts = state.data.productos || [];
  const products = searchFilter(allProducts, query, ["codigo_interno","nombre","referencia","categoria","unidad"]);
  const tipo = state.editingTipo;
  const isOCP = tipo === "OCP";
  const isRC = tipo === "RC";
  const checked = state.productSearchChecked || {};
  const selectedCount = Object.keys(checked).filter(id => checked[id]).length;

  let listHTML;
  if (allProducts.length === 0) {
    listHTML = `
      <div style="padding:30px;text-align:center;background:#f8fafc;border-radius:6px;color:${C.muted};">
        <div style="font-size:32px;margin-bottom:8px;">📦</div>
        <div>No hay productos en el catálogo</div>
        <div style="font-size:11.5px;margin-top:4px;">Agrégalos desde Maestros → Productos</div>
      </div>
    `;
  } else if (products.length === 0) {
    listHTML = `
      <div style="padding:11px;text-align:center;color:${C.muted};">
        <div style="font-size:17px;margin-bottom:6px;">🔍</div>
        <div style="font-size:12px;">Sin resultados para "${escapeHTML(query)}"</div>
      </div>
    `;
  } else {
    const qtys = state.productSearchQtys || {};
    const isCT = tipo === "CT";
    listHTML = `
      <div id="catalog-product-list" style="max-height:380px;overflow-y:auto;border:1px solid ${C.border};border-radius:6px;">
        ${products.map((p, _ci) => {
          const isChecked = !!checked[p.id];
          const _costoP = parseNumber(p.costo) || 0;
          const _margenP = parseNumber(p.margen) || 0;
          const _compP = 1 - (_margenP / 100);
          const _precioCalcP = (_compP > 0 && _costoP > 0) ? Math.round(_costoP / _compP) : (parseNumber(p.precio_venta) || 0);
          const defaultPrice = isOCP ? _costoP : _precioCalcP;
          // Lo que se puede prometer: el kardex menos lo que ya está vendido
          // y pendiente de entregar (ver getComprometidoPorEntregar).
          const _enBodega = getStockProducto(p.nombre);
          const _comp = getComprometidoPorEntregar(p.nombre, null);
          const _stk = _enBodega - _comp;
          const _qty = qtys[p.id] !== undefined ? qtys[p.id] : "";
          const _qtyNum = parseNumber(_qty) || 0;
          // Color stock: rojo=sin stock, amarillo=insuficiente, verde=OK
          const _stkCol = _stk === 0 ? "#dc2626" : (_qtyNum > 0 && _stk < _qtyNum ? "#f59e0b" : "#16a34a");
          const _stkLabel = _stk === 0 ? "Sin stock" : (_qtyNum > 0 && _stk < _qtyNum ? "Insuficiente" : "Disponible");
          // Siguiente item seleccionado (para Tab)
          const _nextId = products.slice(_ci + 1).find(pp => !!checked[pp.id]) || null;
          const _nextQtyId = _nextId ? "cat-qty-" + _nextId.id : "__none__";
          return `
          <div style="padding:7px 10px;display:flex;align-items:center;gap:10px;border-bottom:1px solid ${C.border};transition:background .15s;background:${isChecked ? C.purple+'10' : 'white'};" onmouseover="this.style.background='#f1f5f9'" onmouseout="this.style.background='${isChecked ? C.purple+'10' : 'white'}'">
            <input type="checkbox" data-action="toggle-catalog-checkbox" data-id="${p.id}" ${isChecked?"checked":""} style="cursor:pointer;width:18px;height:18px;flex-shrink:0;"/>
            <div style="flex:1;min-width:0;">
              <div style="font-weight:700;color:${C.text};font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                ${p.codigo_interno ? `<span style="font-family:ui-monospace,monospace;color:${C.muted};font-weight:600;">${escapeHTML(p.codigo_interno)}</span> ` : ""}${escapeHTML(p.nombre)}
              </div>
              <div style="font-size:10px;color:${C.muted};margin-top:1px;">
                ${p.categoria ? "📁 " + escapeHTML(p.categoria) : ""}
                ${p.unidad ? " • " + escapeHTML(p.unidad) : ""}
                ${p.referencia ? " • ref " + escapeHTML(p.referencia) : ""}
              </div>
            </div>
            ${!isRC ? `
            <div style="text-align:right;flex-shrink:0;">
              <div style="font-weight:700;color:${C.mathiz};font-size:11.5px;">${fmtCOP(defaultPrice)}</div>
              <div style="font-size:9px;color:${C.muted};">${isOCP ? "costo" : "venta"}</div>
            </div>` : ""}
            ${(isCT || tipo==="OP" || isOCP) ? `
            <div style="flex-shrink:0;display:flex;flex-direction:column;align-items:center;gap:2px;">
              <span style="font-size:9px;color:${_comp>0?"#b45309":C.muted};font-weight:600;text-transform:uppercase;letter-spacing:.4px;">${_comp>0?"Disponible*":"Stock"}</span>
              <input type="number" readonly tabindex="-1" value="${_stk}"
                style="width:58px;padding:3px 5px;border:1px solid ${_stkCol}50;border-radius:6px;font-size:11.5px;font-weight:700;text-align:center;background:${_stkCol}15;color:${_stkCol};cursor:default;outline:none;pointer-events:none;"
                title="${_stkLabel}: ${_stk} unidades disponibles${_comp>0?` — hay ${_enBodega} en bodega, pero ${_comp} ya están facturadas y pendientes de entregar`:""}"
              />
              <span style="font-size:9px;color:${_stkCol};font-weight:700;">${_stkLabel}</span>
            </div>
            <div style="flex-shrink:0;display:flex;flex-direction:column;align-items:center;gap:2px;">
              <span style="font-size:9px;color:${isChecked?C.muted:'#d1d5db'};font-weight:600;text-transform:uppercase;letter-spacing:.4px;">Cantidad</span>
              <input
                id="cat-qty-${p.id}"
                type="number" min="1" step="1"
                value="${_qty}"
                placeholder="1"
                tabindex="-1"
                ${isChecked ? "" : "disabled"}
                oninput="handleCatalogQty(this, '${p.id.replace(/\\/g,'\\\\').replace(/'/g,"\\'")}');"
                onkeydown="if(event.key==='Tab'&&!event.shiftKey){const _nx=document.getElementById('${_nextQtyId}');if(_nx&&!_nx.disabled){event.preventDefault();_nx.focus();_nx.select();}} event.stopPropagation();"
                style="width:58px;padding:3px 5px;border:1px solid ${isChecked?C.purple:'#e5e7eb'};border-radius:6px;font-size:12px;font-weight:700;text-align:center;background:${isChecked?'white':'#f3f4f6'};color:${isChecked?C.text:'#d1d5db'};outline:none;transition:border-color .15s,background .15s;cursor:${isChecked?'text':'not-allowed'};"
                onfocus="if(!this.disabled){this.style.borderColor='${C.purple}';this.style.boxShadow='0 0 0 2px ${C.purple}30';this.select();}"
                onblur="this.style.borderColor='${isChecked?C.purple:'#e5e7eb'}';this.style.boxShadow='none';"
              />
            </div>` : ""}
          </div>
        `}).join("")}
      </div>
    `;
  }



  state.modal = `
    <div data-action="close-modal-bg" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.45);display:flex;align-items:center;justify-content:center;z-index:1100;padding:11px;">
      <div data-action="prevent-close" style="background:white;border-radius:14px;width:600px;max-width:100%;max-height:90vh;overflow:auto;box-shadow:0 20px 60px rgba(0,0,0,.2);">
        <div style="padding:10px 12px;border-bottom:1px solid ${C.border};display:flex;justify-content:space-between;align-items:center;background:#f8fafc;">
          <h3 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">📦 Buscar producto del catálogo</h3>
          <button data-action="close-product-search" style="background:transparent;border:none;font-size:16px;color:${C.muted};cursor:pointer;">✕</button>
        </div>
        <div style="padding:11px;">
          <div style="position:relative;margin-bottom:9px;">
            <span style="position:absolute;left:12px;top:50%;transform:translateY(-50%);font-size:14px;color:${C.muted};">🔍</span>
            <input
              id="product-search-input"
              type="text"
              value="${escapeHTML(query)}"
              placeholder="Buscar por nombre, categoría o unidad..."
              data-search="product-search-input"
              style="${inputStyle}padding-left:36px;"
            />
          </div>
          ${query ? `<div style="font-size:10.5px;color:${C.muted};margin-bottom:10px;">Mostrando ${products.length} de ${allProducts.length}</div>` : ""}
          ${products.length > 0 ? `
          <div style="display:flex;gap:8px;margin-bottom:10px;flex-wrap:wrap;">
            <button data-action="catalog-select-all" style="${btnStyle(null,"secondary",true)}">Seleccionar todos los visibles</button>
            <button data-action="catalog-clear-selection" style="${btnStyle(null,"secondary",true)}">Limpiar selección</button>
          </div>
          ` : ""}
          ${listHTML}
          <div style="margin-top:14px;display:flex;justify-content:space-between;align-items:center;gap:10px;flex-wrap:wrap;padding-top:12px;border-top:1px solid ${C.border};">
            <div data-catalog-count style="font-size:11.5px;color:${C.muted};">${selectedCount} producto${selectedCount!==1?"s":""} seleccionado${selectedCount!==1?"s":""}</div>
            <div style="display:flex;gap:8px;">
              <button data-action="close-product-search" style="${btnStyle(null,"secondary")}">Cerrar</button>
              <button data-action="confirm-add-selected-products" ${selectedCount===0?"disabled":""} style="${btnStyle(C.accent)}${selectedCount===0?"opacity:.5;cursor:not-allowed;":""}">+ Agregar ${selectedCount||""} a la ${isRC ? "remisión" : DOC_INFO[tipo].label.toLowerCase()}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
  render();

  // Mantener foco en el input de búsqueda solo en desktop
  // En móvil NO hacer focus automático para evitar que el teclado aparezca
  setTimeout(() => {
    if (window.innerWidth > 768) {
      const input = document.getElementById("product-search-input");
      if (input) {
        input.focus();
        input.setSelectionRange(input.value.length, input.value.length);
      }
    }
  }, 0);
}

export function addCatalogProductToDoc(product) {
  const tipo = state.editingTipo;
  const isOCP = tipo === "OCP";
  const isRC = tipo === "RC";

  const qtys = state.productSearchQtys || {};
  const qty = (qtys[product.id] && Number(qtys[product.id]) > 0) ? Number(qtys[product.id]) : 1;
  const _costo = parseNumber(product.costo) || 0;
  const _margen = parseNumber(product.margen) || 0;
  const _comp = 1 - (_margen / 100);
  const _precioCalc = (_comp > 0 && _costo > 0) ? Math.round(_costo / _comp) : (parseNumber(product.precio_venta) || 0);
  const defaultPrice = isOCP ? _costo : _precioCalc;

  if (isRC) {
    const newItem = {
      articulo: product.nombre,
      descripcion: product.categoria || "",
      referencia: product.referencia || "",
      cantidad: qty,
      bolsas: 1,
      observaciones: ""
    };
    state.editingDoc.items = [...(state.editingDoc.items || []), newItem];
  } else {
    const newItem = {
      articulo: product.nombre,
      descripcion: product.categoria || "",
      referencia: product.referencia || "",
      color: "", logo: "", impresion: "",
      cantidad: qty,
      precio_unitario: defaultPrice,
      total: qty * defaultPrice
    };
    if (isOCP) newItem.ubicacion = "";
    else newItem.tinta = "";
    state.editingDoc.items = [...(state.editingDoc.items || []), newItem];
  }
}

import { registerActions } from "../ui/actions.js";

registerActions({
  "search-products": (d, el, e) => {showProductSearch();
      return;},
  "toggle-catalog-checkbox": (d, el, e) => {{
      const _listEl = document.getElementById("catalog-product-list");
      const _savedScroll = _listEl ? _listEl.scrollTop : 0;
      if (!state.productSearchChecked) state.productSearchChecked = {};
      const _wasChecked = !!state.productSearchChecked[d.id];
      if (_wasChecked) {
        delete state.productSearchChecked[d.id];
        // Limpiar cantidad al desmarcar
        if (state.productSearchQtys) delete state.productSearchQtys[d.id];
      } else {
        state.productSearchChecked[d.id] = true;
      }
      renderProductSearchModal();
      requestAnimationFrame(() => {
        const _el = document.getElementById("catalog-product-list");
        if (_el) _el.scrollTop = _savedScroll;
        // Si se acaba de marcar, enfocar el input de cantidad para que el usuario escriba directo
        if (!_wasChecked) {
          const _qtyEl = document.getElementById("cat-qty-" + d.id);
          if (_qtyEl && !_qtyEl.disabled) { _qtyEl.focus(); _qtyEl.select(); }
        }
      });
      return;
    }},
  "catalog-select-all": (d, el, e) => {{
      const query = state.productSearch || "";
      const allProducts = state.data.productos || [];
      const products = searchFilter(allProducts, query, ["codigo_interno","nombre","referencia","categoria","unidad"]);
      if (!state.productSearchChecked) state.productSearchChecked = {};
      products.forEach(p => { state.productSearchChecked[p.id] = true; });
      const _listElSA = document.getElementById("catalog-product-list");
      const _savedScrollSA = _listElSA ? _listElSA.scrollTop : 0;
      renderProductSearchModal();
      requestAnimationFrame(() => {
        const _elSA = document.getElementById("catalog-product-list");
        if (_elSA) _elSA.scrollTop = _savedScrollSA;
      });
      return;
    }},
  "catalog-clear-selection": (d, el, e) => {{
      state.productSearchChecked = {};
      state.productSearchQtys = {};
      renderProductSearchModal();
      return;
    }},
  "confirm-add-selected-products": (d, el, e) => {{
      const checked = state.productSearchChecked || {};
      const ids = Object.keys(checked).filter(id => checked[id]);
      if (ids.length === 0) return;
      ids.forEach(id => {
        const product = state.data.productos.find(p => p.id === id);
        if (product) addCatalogProductToDoc(product);
      });
      state.productSearch = "";
      state.productSearchChecked = {};
      state.productSearchQtys = {};
      // Volver al formulario del documento para ajustar cantidades y precios
      renderDocFormModal();
      return;
    }},
  "close-product-search": (d, el, e) => {if (state.editingDoc) {
        state.productSearch = "";
        state.productSearchChecked = {};
        state.productSearchQtys = {};
        renderDocFormModal();
      } else {
        state.modal = null;
        state.productSearch = "";
        state.productSearchChecked = {};
        state.productSearchQtys = {};
        render();
      }
      return;},
});
